import { dialogResolvers } from './dialog';
import { notificationResolver } from './notification';
import { statusbarResolver } from './statusbar';
import { configurationResolvers } from './configuration';
import { contextResolvers } from './context';
import { keybindingsResolvers } from './keybindings';
import { contextMenuResolvers } from './contextmenu';
import { quickInputModelResolver } from './quickInputModel';
import { gotoLineQuickAccessResolvers } from './gotoLineQuickAccess';
import { workspaceResolver } from './workspace';

export const resolvers =
    [dialogResolvers, notificationResolver, configurationResolvers, contextResolvers, statusbarResolver, keybindingsResolvers,
            contextMenuResolvers, quickInputModelResolver, gotoLineQuickAccessResolvers, workspaceResolver];
